
import {DateFormatter,TimeFormatter} from '@/utils/functions/helperFunctions';


export const DateTimeFormatterComp = (props: any) => {
    return <div>
        <span
            className="text-foreground">
            <span>
                {props.children && DateFormatter(props.children)}
            </span>
        </span>
        <div>
            <div className='meta mt-1'>
                <span className="version">
                    <span className="text-muted-foreground">
                        {props.children && TimeFormatter(props.children)}
                    </span>
                </span>
            </div>
        </div>
    </div>
}